import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperImageOptions, MapperOptions } from '~/types'
import { mapperModuleInternalVideo, mapperModuleMedia, mapperModuleNavigationLink, mapperModuleVideo } from '../mappers'

/**
 * Module Metric mapper
 * @param {Object} data - content data
 * @return {Object} - normalized data
 */
const mapMedia = (item: any, imageOptions: MapperImageOptions): Record<string, any> => {
  const contentType = item?.contentType || 'ModuleMedia'

  switch (contentType) {
    case 'ModuleMedia': {
      return { image: mapperModuleMedia(item, imageOptions) }
    }
    case 'ModuleVideo': {
      return { video: mapperModuleVideo(item, imageOptions) }
    }
    case 'ModuleInternalVideo': {
      return { video: mapperModuleInternalVideo(item, imageOptions) }
    }
    default: {
      return {}
    }
  }
}

export const mapperModuleExpandableCard = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const getBenefits = (data: any) => {
    const benefits = []

    for (let i = 1; i <= 5; i++) {
      const key = `benefit${i}Title`
      const textKey = `benefit${i}Text`

      if (data[key]) {
        const benefit = {
          title: data[key],
          text: data[textKey]
        }

        benefits.push(benefit)
      }
    }
    return benefits
  }

  return {
    id: data.sys?.id || '',
    icon: mapperIcon(data.icon),
    eyebrow: data.eyebrow || '',
    title: data.title || '',
    description: data.description || '',
    ...mapMedia(data.media, options.imageOptions),
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    benefits: getBenefits(data) || []
  }
}
